import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem('no_user');
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('no_token', data.token);
    localStorage.setItem('no_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const loginWithToken = async (token) => {
    localStorage.setItem('no_token', token);
    const { data } = await api.get('/users/me');
    localStorage.setItem('no_user', JSON.stringify(data));
    setUser(data);
    return data;
  };

  // Used after a successful password change or profile edit to sync state
  const setUserData = (updated) => {
    localStorage.setItem('no_user', JSON.stringify(updated));
    setUser(updated);
  };

  const logout = () => {
    localStorage.removeItem('no_token');
    localStorage.removeItem('no_user');
    setUser(null);
  };

  const can = (...roles) => user && roles.includes(user.role);

  return (
    <AuthContext.Provider value={{ user, login, loginWithToken, logout, loading, can, setUserData }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
